import { CountMessageEndpointType, MenuAreaType } from 'app/services/menu.service';

export class AppPageModel {
	title?:   string;
	url?:     string;
	icon?:    string = "car";
	iconalt?: string = "";
	disablefill?: boolean = false;
	child?: boolean = false;
	count?: CountMessageEndpointType
    type?: 'page' | 'divider' = 'page';
	triggerSubmenu?: boolean = false;
	children?: AppPageModel[];
	subMenuOpen?: boolean = false;
	clickEvent?: string;
	remindersBadge?: boolean = false;
    spinner?: boolean;           
    statusIcon?: string;  
    statusIconColor?: string;  
}

export class AppPageGroupModel {
	area: MenuAreaType;
	pages: AppPageModel[];
	name: string;
}
